import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 1500000 });

export default class AfiliadoConfig {
	static get endpoint() {
		return Settings.server + "/affiliates";
	}

	static get endpointGetContributions() {
		return `${AfiliadoConfig.endpoint}/getContributions`;
	}

	static get endpointImportData() {
		return `${AfiliadoConfig.endpoint}/import-data`;
	}

	static get endpointGenerateAffiliateCard() {
		return `${AfiliadoConfig.endpoint}/affiliate-card`;
	}

	static get baseDomain() {
		return Settings.serverDomain;
	}

	static get endpointReport() {
		return `${AfiliadoConfig.baseDomain}/report`;
	}

	static get endpointValidateCUIL() {
		return `${AfiliadoConfig.endpoint}/validate-cuil`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/Afiliado/AfiliadoConfig.js